<template src="./template.html"></template>

<script>
import Vue from 'vue'
import TENKENGYOUMU_DETAIL from 'src/consts/tenkengyoumu_detail'
import HASONJOUKYOU from 'src/consts/hasonjoukyou'
import HASONBASHO from 'src/consts/hasonbasho'
import masterMixin from 'src/mixins/masterMixin'
import notificationMixin from 'src/mixins/notificationMixin'
import pierMixin from 'src/mixins/pierMixin'
import poleMixin from 'src/mixins/poleMixin'
import jointMixin from 'src/mixins/jointMixin'
import tenkenDataBaseApi from 'src/apis/tenken_data_base'
import tenkenDataDetailApi from 'src/apis/tenken_data_rojou'

export default {
  displayPageName: '詳細結果入力',
  data() {
    return {
      tdd: null,

      photoSelectorModalTitle: '写真選択',

      showPhotoSelectorModal: false,
      showSaveModal: false,
      showBeforeBackModal: false,

      ukeoigyoushaCands: [],
      staffCands: [],
      tantoujimushoCands: [],
      tenkenKubunCands: [],
      tekiyouCands: [],
      rosenCands: [],
      rosenHoukouCands: [],
      honsenranpuKubunCands: [],
      shasenKubunCands: [],
      hasonbashoCands: [],
      origHasonjoukyouCands: [],
      hasonjoukyouCands: [],
      origBuiCands: [],
      buiCands: [],
      origShinshukutsugiteZaishitsuCands: [],
      shinshukutsugiteZaishitsuCands: [],
      origShinshukutsugiteTypeCands: [],
      shinshukutsugiteTypeCands: [],
      hanteiCands: [],
      sayuuCands: [],
      yesNoCands: [],

      isRequesting: false,

      bgColorFlgInfo: {},
    }
  },
  computed: {
    isNew() {
      return this.$route.path.endsWith('/new')
    },
    isDetailGyoumuDoboku() {
      return parseInt(this.tdd.detail_gyoumu_id) === TENKENGYOUMU_DETAIL.DOBOKU
    },
    isDetailGyoumuShisetsuDenki() {
      return parseInt(this.tdd.detail_gyoumu_id) === TENKENGYOUMU_DETAIL.SHISETSU_DENKI
    },
    isTenkenKubunShinshukutsugite() {
      return this.shinshukutsugiteZaishitsuCands.length > 0
    },
    isHasonjoukyouSonota() {
      return parseInt(this.tdd.hasonjoukyou_id) === HASONJOUKYOU.SONOTA
    },
    hasHasonbasho() {
      const hasonbashoId = this.tdd.hasonbasho_id
      const hasonbashoNo = this.tdd.hasonbasho_no
      const hasHasonbashoId = hasonbashoId !== null &&
        hasonbashoId !== undefined &&
        hasonbashoId !== ''
      const hasHasonbashoNo = hasonbashoNo !== null &&
        hasonbashoNo !== undefined &&
        hasonbashoNo !== ''
      return hasHasonbashoId && hasHasonbashoNo
    },
    usedPhotos() {
      const photos = this.tdd.photos
      if (!photos || photos.length === 0) { return [] }
      return photos
        .filter(e => e.is_used)
        .slice().sort((a, b) => a.disp_order - b.disp_order)
    },
    showDobokuSuuryouSonota() {
      return this.hasDobokuSuuryouProps(this.tdd)
    },
  },
  async mounted() {
    const promises = [
      this.ensureUserAndMasters(),
      this.getTenkenDataDetail(),
    ]
    await Promise.all(promises)
    this.prepareMasters()
    if (this.isNew) {
      // 担当事務所をセットする
      if (this.tantoujimushoCands.length > 0) {
        this.tdd.jimusho_id =
          this.tantoujimushoCands[0].m_tantoujimusho_id
      }
    }
  },
  mixins: [masterMixin, notificationMixin, pierMixin, poleMixin, jointMixin],
  methods: {
    getTenkenDataDetailForDisp(tdd) {
      // alias
      tdd.tdb = tdd.tenken_data_base
      tdd.ds = tdd.doboku_suuryou

      // 発見時間
      if (tdd.hakkenjikan) {
        const hm = tdd.hakkenjikan.split(':')
        tdd.hakkenjikan_h = hm[0]
        tdd.hakkenjikan_m = hm[1]
      }
      // 写真
      if (tdd.photos.length > 0) {
        tdd.photos.forEach(e => {
          e.src = e.signed_id // alias
        })
      }
      return tdd
    },
    async getTenkenDataDetail() {
      let tdd = {}
      if (this.isNew) {
        const { data } = await tenkenDataBaseApi.show(this.$route.params.base_id)
        tdd.base_id = data.base_id
        tdd.detail_gyoumu_id = this.$route.query.detail_gyoumu_id
        tdd.tenken_data_base = data
        tdd.photos = []
        tdd = this.getTenkenDataDetailForDisp(tdd)
      } else {
        const { data } = await tenkenDataDetailApi.show(this.$route.params.detail_id)
        tdd = this.getTenkenDataDetailForDisp(data)
      }
      this.tdd = tdd
    },
    filterByGyoumu(items) {
      const tdd = this.tdd
      return items.filter(e => {
        return (e.tenkengyoumu_base_id === tdd.tdb.tenken_gyoumu_id) &&
          (e.tenkengyoumu_detail_id === tdd.detail_gyoumu_id)
      })
    },
    filterByTenkenDate(items) {
      const dt = new Date(this.tdd.tdb.tenken_date)
      return items.filter(e => {
        const startDt = new Date(e.start_date)
        const endDt = new Date(new Date(e.end_date).valueOf() + 86400 * 1000)
        return (startDt <= dt) && (dt < endDt)
      })
    },
    filterByTenkenKubun(items) {
      return items.filter(e => {
        return e.tenkenkubun_id === this.tdd.tenkenkubun_id
      })
    },
    prepareMasters() {
      const master = window.master
      // 点検請負者
      this.ukeoigyoushaCands = master.ukeoigyousha.vals
      // 点検責任者, 点検員
      this.staffCands = master.staff.vals
      // 担当事務所
      let tantoujimushoCands = this.tdd.tdb.rosen.tantoujimusho_list
      tantoujimushoCands = tantoujimushoCands
        .filter(e => e.detail_gyoumu_id === this.tdd.detail_gyoumu_id)
      tantoujimushoCands = this.filterByTenkenDate(tantoujimushoCands)
      this.tantoujimushoCands = tantoujimushoCands
      // 点検区分
      let tenkenKubunCands = master.tenken_kubun.vals
      tenkenKubunCands = this.filterByGyoumu(tenkenKubunCands)
      tenkenKubunCands = this.filterByTenkenDate(tenkenKubunCands)
      this.tenkenKubunCands = tenkenKubunCands
      // 摘要欄
      this.tekiyouCands = master.tekiyou.vals
      // 路線
      this.rosenCands = master.rosen.vals
      // 路線方向
      this.rosenHoukouCands = master.rosen_houkou.vals
        .filter(e => e.rosen_id === this.tdd.tdb.rosen_id)
      // 本線ランプ区分
      this.honsenranpuKubunCands = this.filterByTenkenDate(master.honsenranpu_kubun.vals)
      // 車線区分
      this.shasenKubunCands = master.shasen_kubun.vals
      // 破損場所
      this.hasonbashoCands = master.hasonbasho.vals
      // 破損状況
      this.origHasonjoukyouCands = this.filterByGyoumu(master.hasonjoukyou.vals)
      this.hasonjoukyouCands = this.filterByTenkenKubun(this.origHasonjoukyouCands)
      // 部位
      this.origBuiCands = this.filterByGyoumu(master.bui.vals)
      this.buiCands = this.filterByTenkenKubun(this.origBuiCands)
      // 伸縮継手材質
      this.origShinshukutsugiteZaishitsuCands = this.filterByGyoumu(master.shinshukutsugite_zaishitsu.vals)
      this.shinshukutsugiteZaishitsuCands = this.filterByTenkenKubun(this.origShinshukutsugiteZaishitsuCands)
      // 伸縮継手形式
      this.origShinshukutsugiteTypeCands = this.filterByGyoumu(master.shinshukutsugite.vals)
      this.shinshukutsugiteTypeCands = this.filterByTenkenKubun(this.origShinshukutsugiteTypeCands)
        .filter(e => e.zaishitsu_id === this.tdd.shinshukutsugite_zaishitsu_id)
      // 土木関係数量
      this.dobokuSuuryouCands = this.filterByGyoumu(master.doboku_suuryou.vals)
      // 判定
      this.hanteiCands = this.filterByTenkenDate(master.hantei.vals)
      // 左右区分
      this.sayuuCands = master.lovs.position.vals
      // 事故情報, 原因者
      this.yesNoCands = master.lovs.yes_no.vals
    },
    hasDobokuSuuryouProps(tdd) {
      const hasSuuryouNames = tdd.suuryou1_nm || tdd.suuryou2_nm || tdd.suuryou3_nm
      const hasCheckNames = tdd.check1_nm || tdd.check2_nm || tdd.check3_nm
      return hasSuuryouNames || hasCheckNames
    },
    setDobokuSuuryouProps() {
      // 点検区分と破損状況から土木関係数量を取得
      const tdd = Object.assign({}, this.tdd)
      tdd.ds = this.dobokuSuuryouCands.find(e => {
        return (e.tenkenkubun_id === tdd.tenkenkubun_id) &&
          (e.hasonjoukyou_id === tdd.hasonjoukyou_id)
      })

      // 数量名, チェック名をセットする
      const ds = tdd.ds
      const numArr = ['1', '2', '3']
      numArr.forEach(e => {
        let suuryouName = null
        let checkName = null
        if (ds) {
          suuryouName = ds[`suuryou${e}_nm`]
          checkName = ds[`check${e}_nm`]
        }
        tdd[`suuryou${e}_nm`] = suuryouName
        tdd[`check${e}_nm`] = checkName
        tdd[`suuryou${e}_nu`] = suuryouName ? tdd[`suuryou${e}_nu`] : null
        tdd[`check${e}_flg`] = checkName ? tdd[`check${e}_flg`] : null
      })
      if (!this.hasDobokuSuuryouProps(tdd)) {
        tdd.sonota_nu = null
      }
      this.tdd = tdd
    },
    onHasonjoukyouChange() {
      // 土木関係の値をセットする
      this.setDobokuSuuryouProps()
    },
    onShinshukutsugiteZaishitsuChange() {
      // 伸縮継手形式絞り込み
      this.shinshukutsugiteTypeCands = this.filterByTenkenKubun(this.origShinshukutsugiteTypeCands)
        .filter(e => e.zaishitsu_id === this.tdd.shinshukutsugite_zaishitsu_id)

      const tdd = Object.assign({}, this.tdd)
      // 伸縮継手形式初期化
      tdd.shinshukutsugite_type_id = null
      this.tdd = tdd
    },
    onTenkenKubunChange() {
      // 破損状況絞り込み
      this.hasonjoukyouCands = this.filterByTenkenKubun(this.origHasonjoukyouCands)
      // 部位絞り込み
      this.buiCands = this.filterByTenkenKubun(this.origBuiCands)
      // 伸縮継手絞り込み
      this.shinshukutsugiteZaishitsuCands = this.filterByTenkenKubun(this.origShinshukutsugiteZaishitsuCands)

      const tdd = Object.assign({}, this.tdd)
      // 破損状況初期化
      tdd.hasonjoukyou_id = null
      // 部位1初期化
      tdd.bui1_id = null
      // 部位2初期化
      tdd.bui2 = ''
      // 伸縮継手材質初期化
      tdd.shinshukutsugite_zaishitsu_id = null
      this.tdd = tdd

      this.onHasonjoukyouChange()
      this.onShinshukutsugiteZaishitsuChange()
    },
    async getPiers() {
      if (this.isRequesting) { return }

      this.isRequesting = true
      try {
        const tdd = Object.assign({}, this.tdd)
        const bgColorFlgInfo = this.bgColorFlgInfo

        const honsenranpuKubun = this.honsenranpuKubunCands
          .find(e => e.m_honsenranpu_kubun_id === tdd.honsenranpu_id)
        const rosenHoukou = this.rosenHoukouCands
          .find(e => e.m_rosen_houkou_id === tdd.houkou_id)
        const hasonbashoInfo = {
          hasonbashoId: tdd.hasonbasho_id,
          hasonbashoNo: tdd.hasonbasho_no,
          rosenNameKodan: tdd.tdb.rosen.name_kodan,
          rosenHoukouName: rosenHoukou ? rosenHoukou.name : '',
          honsenranpuKubunName: honsenranpuKubun ? honsenranpuKubun.name : '',
        }
        const pierInfo = await this.getPiersByHasonbasho(hasonbashoInfo)

        if (pierInfo.errorMsg) {
          this.notifyError1(pierInfo.errorMsg)
        } else {
          tdd.shikyaku_no = pierInfo.shikyakuNo
          tdd.shuukyaku_no = pierInfo.shuukyakuNo
          bgColorFlgInfo.shikyakuNo = true
          bgColorFlgInfo.shuukyakuNo = true
        }

        this.tdd = tdd
        this.bgColorFlgInfo = bgColorFlgInfo
        this.isRequesting = false
      } catch (err) {
        const msg = '橋脚番号の取得に失敗しました。' +
          '管理者にご連絡ください。'
        this.notifyError1(msg, { err })
        this.isRequesting = false
      }
    },
    async setDataByPhotoGeoInfo(photo) {
      if (this.usedPhotos.length > 1) { return }

      const metadata = photo.metadata
      if (!metadata) { return }

      const tdd = Object.assign({}, this.tdd)
      const bgColorFlgInfo = {}

      const datetime = metadata.datetime
      const lat = metadata.latitude
      const lon = metadata.longitude
      const geoLocations = metadata.geo_locations

      // 緊急通報から切り出した場合は、動画から取得したポール情報をmetadataに入れてある
      let pole = metadata.pole
      let joint = null
      if (!pole) {
        // 写真の位置情報をもとにポールとジョイントを取得
        [pole, joint] = await Promise.all([
          this.getPoleByGeoInfo(lat, lon, geoLocations),
          this.getJointByGeoInfo(lat, lon, geoLocations),
        ])
      } else {
        // 写真の位置情報をもとにジョイントを取得
        joint = await this.getJointByGeoInfo(lat, lon, geoLocations)
      }

      if (lat !== '' && lon !== '') {
        tdd.location_info = { lat, lon }
      }
      if (datetime) {
        const dtFormat = Vue.filter('dtFormat')
        const dt = new Date(datetime)
        tdd.hakkenjikan_h = dtFormat(dt, 'HH')
        tdd.hakkenjikan_m = dtFormat(dt, 'MM')
        bgColorFlgInfo.hakkenjikan = true
      }
      if (pole) {
        const rosenHoukou = this.rosenHoukouCands
          .find(e => e.name === pole.direction)
        const hasonbasho = this.hasonbashoCands
          .find(e => parseInt(e.m_hasonbasho_id) === HASONBASHO.POLE)
        const hasonbashoNo = this.getPoleNoInputFormat(pole.code)
        const { shikyakuNo, shuukyakuNo } =
          await this.getPiersByPole(hasonbashoNo, tdd.tdb.rosen.name_kodan)

        if (rosenHoukou) {
          tdd.houkou_id = rosenHoukou.m_rosen_houkou_id
          bgColorFlgInfo.houkouId = true
        }
        if (hasonbasho) {
          tdd.hasonbasho_id = hasonbasho.m_hasonbasho_id
          bgColorFlgInfo.hasonbashoId = true
        }
        if (hasonbashoNo) {
          tdd.hasonbasho_no = hasonbashoNo
          bgColorFlgInfo.hasonbashoNo = true
        }
        if (shikyakuNo && shuukyakuNo) {
          tdd.shikyaku_no = shikyakuNo
          tdd.shuukyaku_no = shuukyakuNo
          bgColorFlgInfo.shikyakuNo = true
          bgColorFlgInfo.shuukyakuNo = true
        }
      }
      if (joint) {
        const thres = 20
        if (joint.joint_number && parseFloat(joint.dict) < thres) {
          tdd.bikou += ' '
          tdd.bikou += joint.joint_number
          bgColorFlgInfo.bikou = true
        }
      }

      this.tdd = tdd
      this.bgColorFlgInfo = bgColorFlgInfo
    },
    getTenkenDataDetailForReq() {
      const ret = this.tdd
      // 発見時間
      const hStr = ret.hakkenjikan_h
      const mStr = ret.hakkenjikan_m
      let hakkenjikan = null
      if (!!hStr && !!mStr) {
        hakkenjikan = `${hStr}:${mStr}`
      }
      ret.hakkenjikan = hakkenjikan
      return ret
    },
    getPhotosForReq() {
      const formData = new FormData()
      for (const photo of this.tdd.photos) {
        formData.append('photos[][id]', photo.id)
        formData.append('photos[][is_used]', photo.is_used)
        formData.append('photos[][disp_order]', photo.disp_order)
        if (photo.isNew) {
          const metadata = photo.metadata
          formData.append('photos[][file]', photo.file, photo.filename)
          formData.append('photos[][metadata][datetime]', metadata.datetime)
          formData.append('photos[][metadata][latitude]', metadata.latitude)
          formData.append('photos[][metadata][longitude]', metadata.longitude)
          formData.append('photos[][metadata][geo_locations]', metadata.geo_locations)
        }
      }
      return formData
    },
    async openSaveModal() {
      const isValid = await this.$refs.tdd.validate()
      if (!isValid) { return }

      this.showSaveModal = true
    },
    async saveTenkenDataDetail() {
      if (this.isRequesting) { return }

      this.isRequesting = true
      try {
        if (this.isNew) {
          await this._createTenkenDataDetail()
        } else {
          await this._updateTenkenDataDetail()
        }
        this.showSaveModal = false
        this.notifySuccess1('詳細結果を保存しました。')
        this.isRequesting = false
      } catch (err) {
        const msg = '詳細結果の保存に失敗しました。' +
          '管理者にご連絡ください。'
        this.notifyError1(msg, { err })
        this.isRequesting = false
      }
    },
    async _createTenkenDataDetail() {
      try {
        const reqObj1 = this.getTenkenDataDetailForReq()
        const reqObj2 = this.getPhotosForReq()
        const { data } = await tenkenDataDetailApi.create(reqObj1)
        await tenkenDataDetailApi.bulkUpdatePhotos(data.detail_id, reqObj2)
        this.$router.replace({
          name: 'RojouTenkenDetail',
          params: { detail_id: data.detail_id }
        })
      } catch (err) {
        console.error('error', err)
        throw err
      }
    },
    async _updateTenkenDataDetail() {
      try {
        const id = this.tdd.detail_id
        const reqObj1 = this.getTenkenDataDetailForReq()
        const reqObj2 = this.getPhotosForReq()
        await tenkenDataDetailApi.update(id, reqObj1)
        await tenkenDataDetailApi.bulkUpdatePhotos(id, reqObj2)
        await this.getTenkenDataDetail()
      } catch (err) {
        console.error('error', err)
        throw err
      }
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
